export default {
  DASHBOARD_DATA_REQUEST: 'APP/DASHBOARD_ACTIVITY/DASHBOARD_DATA_REQUEST',
  DASHBOARD_DATA_SUCCESS: 'APP/DASHBOARD_ACTIVITY/DASHBOARD_DATA_SUCCESS',
  DASHBOARD_DATA_ERROR: 'APP/DASHBOARD_ACTIVITY/DASHBOARD_DATA_ERROR',
  DASHBOARD_DATA_REMOVE: 'APP/DASHBOARD_ACTIVITY/DASHBOARD_DATA_REMOVE',
};
